const cartMutations = {

  changeEvent (state, payload) {
    state.search_event = payload
  }
}

export { cartMutations }
